var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.341 5.03973L11.0524 4.4115L9.13274 0.532973C9.07916 0.421044 9.0039 0.32086 8.91132 0.238224C8.81874 0.155587 8.71069 0.0921374 8.59342 0.0515588C8.47614 0.0109801 8.35199 -0.00591683 8.22813 0.00183029C8.10428 0.00957741 7.9832 0.0418177 7.8719 0.0966939C7.68183 0.189323 7.52825 0.342909 7.43562 0.532973L5.51599 4.4115L1.22736 5.03538C0.984555 5.07517 0.766937 5.20833 0.621011 5.40643C0.475086 5.60453 0.412425 5.85185 0.446419 6.09554C0.477426 6.30075 0.573822 6.49047 0.721277 6.63652L3.82322 9.65121L3.09027 13.9137C3.0485 14.1595 3.10586 14.4118 3.24978 14.6155C3.3937 14.8191 3.61246 14.9573 3.85813 15H4.01519C4.16731 14.9996 4.31703 14.9621 4.45147 14.8909L8.29072 12.8753L12.1256 14.8909C12.3462 15.0065 12.6035 15.0301 12.8414 14.9565C13.0793 14.8829 13.2784 14.7182 13.3952 14.4983C13.4917 14.3149 13.5255 14.1049 13.4912 13.9006L12.7582 9.63812L15.8602 6.62343C16.0307 6.44829 16.1262 6.21348 16.1262 5.96901C16.1262 5.72454 16.0307 5.48973 15.8602 5.31459C15.7158 5.1672 15.5275 5.07073 15.3235 5.03973H15.341Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.437434,
    y1: 7.50017,
    x2: 16.0844,
    y2: 7.50017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66BEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009CDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.77305a1959ac38263320b1d383067b70.svg";
export { ForwardRef as ReactComponent };